var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBpCheckedIcon = function SvgBpCheckedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.9,
    x: 3.00002,
    y: 3.00039,
    width: 10,
    height: 10,
    stroke: "#FA516F",
    strokeWidth: 1.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.80005 7.4668L7.06279 9.72954L11.0226 5.76974",
    stroke: "#FA516F",
    strokeWidth: 1.2
  })));
};
export { SvgBpCheckedIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cmVjdCBvcGFjaXR5PSIwLjkiIHg9IjMuMDAwMDIiIHk9IjMuMDAwMzkiIHdpZHRoPSIxMCIgaGVpZ2h0PSIxMCIgc3Ryb2tlPSIjRkE1MTZGIgogICAgc3Ryb2tlLXdpZHRoPSIxLjIiIC8+CiAgPHBhdGggZD0iTTQuODAwMDUgNy40NjY4TDcuMDYyNzkgOS43Mjk1NEwxMS4wMjI2IDUuNzY5NzQiIHN0cm9rZT0iI0ZBNTE2RiIgc3Ryb2tlLXdpZHRoPSIxLjIiIC8+Cjwvc3ZnPg==";